import { render, staticRenderFns } from "./displayMyName.vue?vue&type=template&id=0d0fb8be&scoped=true&"
import script from "./displayMyName.vue?vue&type=script&lang=js&"
export * from "./displayMyName.vue?vue&type=script&lang=js&"
import style0 from "./displayMyName.vue?vue&type=style&index=0&id=0d0fb8be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0fb8be",
  null
  
)

export default component.exports